/**
* Endpoint methods related to the User
*/

import API from "./Api";
import Csrf from "./Csrf";

export default {
  /**
  * Gets the current user logged-in to the Moodle
  */
  async retrieve() {
    const moodleSession = await Csrf.getCookie();
    return API.post("/auth", { 'cookie': moodleSession });
  },

  /**
  * Registers a User
  */
  async register(form) {

    return API.post("/users/register", form);
  },

  /**
  * Updates the registration count for a signup Form
  */
  async updateCount(form) {

    return API.post("/users/register/count", form);
  },

  /**
  * Registers a Webshop User
  */
  async registerWebShopUser(form) {

    return API.post("webshop/users/register", form);
  },

  /**
  * Logs in a Webshop User
  */
  async loginWebShopUser(form) {
    return API.post("webshop/users/login", form);
  },

  /**
  * Enrolls a Webshop user to the course
  */
  async enrolUser(form) {
    return API.post("webshop/users/enrol", form);
  },

  /**
  * Logs in a user
  */
  async login(form) {
    await Csrf.getCookie();

    return API.post("/login", form);
  },

  /**
  * Logs out a user
  */

  async logout() {
    await Csrf.getCookie();

    return API.post("/logout");
  },

  /**
  * Authenticates a user
  */
  auth() {
    return API.get("/user");
  },

  /**
  * Get all the user information for the logged-in user
  */
  async getAll() {

    return API.get("/users/getallown", "COOKIE_TOKEN_SESSION");
  },


  async getAllByRole(form) {

    return API.post("/users/getbyrole", form, "COOKIE_TOKEN_SESSION");
  },


  async getFirst(form) {
    return API.post("/users/getfirst/", form, "PLAIN_JSON");
  }



};
